/**
 * Session + Study Timer — Prompt.md §22, §23, §26, §27 (quyết định #15).
 */

export interface SessionConfig {
  /**
   * Khoảng nén điểm cho `StudySession.scoreSamples` (§22).
   * 30s → phiên 60 phút có 120 sample, đủ để Report vẽ đường điểm mà record vẫn ~2 KB.
   */
  scoreSampleIntervalMs: number;

  /**
   * Ghi snapshot chưa hoàn tất xuống storage (quyết định #15).
   * 15s là cân bằng giữa "mất nhiều nhất 15 giây dữ liệu" và số lần ghi IndexedDB mỗi phiên
   * (~180 write cho 45 phút — không đáng kể).
   */
  snapshotIntervalMs: number;

  /** §23 — nhắc nghỉ mắt mỗi 25 phút (quy tắc 20-20-20 rút gọn cho trẻ đang học). */
  eyeBreakIntervalMs: number;

  /**
   * Phiên ngắn hơn mốc này không đủ dữ liệu để thống kê (§26 `tooShort`).
   * Vẫn được lưu — phụ huynh thấy "đã học 40 giây" còn đúng hơn là phiên biến mất không dấu vết.
   */
  minReportableDurationMs: number;
}

export const defaultSessionConfig: SessionConfig = {
  scoreSampleIntervalMs: 30_000,
  snapshotIntervalMs: 15_000,
  eyeBreakIntervalMs: 25 * 60_000,
  minReportableDurationMs: 60_000,
};

/** §23 — số phút của từng preset. `custom` lấy từ `SessionOptions.customDurationMs`. */
export const timerPresetMinutes = { 25: 25, 30: 30, 45: 45, 60: 60 } as const;
